export class Machine {
    constructor( 
        public MachineID?: string,
        public ClinicID?: string,
        public ClinicName?: string,
        public LocationID?: string,
        public EquipmentID?: string,
        public LocationName?: string,
        public MachineName?: string,
        public EquipmentShortName?: string,
        public MacAddress?: string,
        public IsActive?: boolean,
        public CreatedBy?: string,
        public CreatedOn?: Date,
        public bDeleted?: boolean,
        public DeletedBy?: string,
        public DeletedOn?: Date,
    ) {}
}